module.exports = __webpack_public_path__ + "img/regular-button.f826ddfe.jpg";